import { SET_TOKEN_ID } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.tokenId, action) {
  switch (action.type) {
    case SET_TOKEN_ID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/tokenId/reducer.js